import * as React from 'react';

export interface ILayoutFormColumnProps {
    /** className to append */
    className?: string;
}

interface IState {
}

/**
 * Column to be used inside LayoutColumns
 */
class LayoutFormColumn extends React.Component<ILayoutFormColumnProps, IState> {
    static displayName: string = 'LayoutFormColumn';

    render () {
        return (
            <div className="layout-form-column">
                {this.props.children}
            </div>
        );
    }
}

export default LayoutFormColumn;
